module.exports = __webpack_public_path__ + "static/img/logojlx.ebadbdc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logojlx.png
// module id = PuQA
// module chunks = 19